/*
import React from "react";
import { auth, provider } from "../firebase-config";
import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function Login({ setIsAuth }) {
  let navigate = useNavigate();

  const signInWithGoogle = () => {
    signInWithPopup(auth, provider).then((result) => {
      localStorage.setItem("isAuth", true);
      setIsAuth(true);
      navigate("/");
    });
  };

  return (
    <div className="loginPage">
      <p>Sign In With Google to Continue</p>
      <button className="login-with-google-btn" onClick={signInWithGoogle}>
        Sign in with Google
      </button>
    </div>
  );
}
*/

import React from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import {useState} from 'react';
import {auth} from '../firebase-config';
import styles from '../Styles/login.css';

function Login({ setIsAuth }) {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const appAuth = auth;

  let navigate = useNavigate();

  const signIn = () => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        localStorage.setItem("isAuth", true);
        setIsAuth(true);
        navigate("/");
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        alert(errorMessage);
      });
  }

  return (
    <div className="wrapper">
        <div className="loginPage">
          <h1 className="addPostTitle">Logowanie</h1>
          <input className="emailInput" type={"email"} placeholder="Podaj email" onChange={(event) => setEmail(event.target.value)}/>
          <input className="passwordInput" type={"password"} placeholder="Podaj hasło" onChange={(event) => setPassword(event.target.value)}/>

          <button className="confirmBtn" onClick={signIn}>Zaloguj się</button>
      </div>
    </div>
  );
}

export default Login;